import React, { FC, useEffect, useRef, useState } from 'react'
// import '../clients/UploadDocumentPopUp.css';
import './CopyFiles.css';
import { CustomerDocumentModelItem } from '../models/superbit-api-models';
import { CustomerCardModel } from '../models/CustomerCardModel';

interface Props {
    documentDetails: CustomerDocumentModelItem;
    onClose: () => void;
    loadData: () => void;
}
const CopyFiles: FC<Props> = ({ documentDetails, onClose, loadData }) => {
    const customerCardModel = useRef(new CustomerCardModel()).current;


    const [folders, setFolders] = useState<any[]>([]);

    const [selectedFolder, setSelectedFolder] = useState<string>('');


    const [relationTypes, setRelationTypes] = useState<any[]>([]);
    const [relationList, setRelationList] = useState<any[]>([]);

    const [showRelationDataList, setShowRelationDataList] = useState<boolean>(false);

    const [finalRelationList, setFinalRelationList] = useState<any[]>([]);

    const [customersList, setCustomersList] = useState<any[]>([]);
    const [customerChosen, setCustomerChosen] = useState<string>('');
    const [customerSearch, setCustomerSearch] = useState<string>('');
    const [isCustomerListOpen, setIsCustomerListOpen] = useState(false);
    // checkbox state
    const [keepCopy, setKeepCopy] = useState<boolean>(false);

    const [relationType, setRelationType] = useState<number>(-1);
    const [relationId, setRelationId] = useState<string>('');

    const filteredCustomers = customersList.filter((client) =>
        client.label.toLowerCase().includes(customerSearch.toLowerCase())
    );

    const init = async () => {

        const relationTypes = await customerCardModel.getRelationTypes();
        if (relationTypes) {
            // If relationTypes is an array, add the new item; if it's an object, adjust accordingly
            const castingArray: any[] = Object.values(relationTypes);
            let newRelationTypes = castingArray.map((item: any) => ({
                id: item.id,
                name: item.name,
                description: item.description || ''
            }));
            newRelationTypes.unshift({
                id: -1,
                name: 'בחר סוג קשר',
                description: 'בחר סוג קשר'
            });
            // remove the item with name 'Treatment' or name 'Signing' or name 'Rider' or name 'Ofer'
            newRelationTypes = newRelationTypes.filter((item: any) => {
                return item.name !== 'Treatment' && item.name !== 'Signing' && item.name !== 'Offer';
            });

            setRelationTypes(newRelationTypes);
        } else {
            // Fallback if relationTypes is not an array
            setRelationTypes([{
                id: -1,
                name: 'בחר סוג קשר',
                description: 'בחר סוג קשר'
            }]);
            console.error('Relation types is not an array:', relationTypes);
        }
    }

    const getCompulsoryRouteId = (policy: any) => {
        if (policy.policyAdditionDetails && policy.policyAdditionDetails.route && policy.policyAdditionDetails.vehiclePolicyType == 6) {
            return policy.policyAdditionDetails.route.compulsoryRouteId ? policy.policyAdditionDetails.route.compulsoryRouteId : ""
        } else if (policy.policyAdditionDetails && policy.policyAdditionDetails.route && policy.policyAdditionDetails.route.routeId) {
            return policy.policyAdditionDetails.route.routeId ? policy.policyAdditionDetails.route.routeId : "";
        }
        return "";
    }

    const fetchFolderAndrelationsForCustomer = async (customerId: string) => {

        const resp = await customerCardModel.customerDocumentsGetFoldersForCustomer(customerId || '');
        if (resp && Array.isArray(resp)) {
            setFolders(resp);
        } else {
            console.error('Failed to fetch folders:', resp);
        }

        let relationData = null;
        const storedRelations = sessionStorage.getItem(`treatmentsRelations-${customerId || ''}`);
        if (storedRelations) {
            relationData = JSON.parse(storedRelations);
            console.log('storedRelations-relationDate-157', relationData)
        } else {
            relationData = await customerCardModel.treatmentsLoadRelations(customerId || '');
            sessionStorage.setItem(`treatmentsRelations-${customerId || ''}`, JSON.stringify(relationData));
        }
        if (relationData) {

            let leadsList = relationData.leads.map((lead: any) => ({
                id: lead.id,
                name: lead.identifier || '',
                type: 'Lead',
            }));
            let policiesList = relationData.policies.map((policy: any) => ({
                id: policy.id,
                name: getCompulsoryRouteId(policy) + " - " + policy.policyNumber + "/" + (policy.additionNumber ? policy.additionNumber : ''), //. add additional number before policy number and add - with branch number
                type: 'Policy',

            }));
            let suesList = relationData.sues.map((sue: any) => ({
                id: sue.id,
                name: sue.sueNumber || '',
                type: 'Sue',
            }));
            let riderList = relationData.riders.map((rider: any) => ({
                id: rider.id,
                name: rider.subscriberNumber || '',
                type: 'Rider',
            }));
            let newlist = [...leadsList, ...policiesList, ...suesList, ...riderList];
            setRelationList(newlist);
        }



    }

    useEffect(() => {

        const allCustomer = sessionStorage.getItem('allCustomers');
        if (allCustomer) {
            const customers = JSON.parse(allCustomer);
            setCustomersList(customers);
        }
        init();

    }, [])

    useEffect(() => {

        if (customerChosen) {
            fetchFolderAndrelationsForCustomer(customerChosen);
        }
    }, [customerChosen]);

    const onSave = async (e: any) => {
        e.preventDefault();

        const payload = {
            filePath: documentDetails.filePath,
            fileSize: documentDetails.fileSize,
            customerId: customerChosen,
            userId: documentDetails.userId,
            name: documentDetails.name,
            relationType: relationType,
            relationId: relationId,
            customerDocumentFolderId: selectedFolder,
        };

        const resp = await new CustomerCardModel().customerDocumentsCreateFile(payload);
        if (resp && resp.statusCode === 200) {
            if (!keepCopy) {
                await new CustomerCardModel().customerDocumentsDeleteFile(documentDetails.id || '').then(() => {
                    console.log('File deleted successfully');
                }).catch((error) => {
                    console.error('Error deleting file:', error);
                });

            }
            alert('הקובץ הועבר בהצלחה');
            onClose();
            loadData();
        } else {
            alert('שגיאה בהעברת הקובץ, נסה שנית מאוחר יותר');
        }
    }

    const getNameInHebrew = (name: string) => {
        if (!name) return name;
        // Check if the name exists in the dictionary and return its Hebrew name
        // If not found, return the original name
        switch (name) {
            case 'Policy':
                return 'פוליסה';
            case 'Lead':
                return 'ליד';
            case 'Sue':
                return 'תביעה';
            case 'Ofer':
                return 'הצעה';
            case 'Rider':
                return 'ריידר';
            case 'Signing':
                return 'חתימה';
            case 'Treatment':
                return 'טיפול שוטף';
            default:
                return name; // Return the original name if not found in the dictionary 
        }
    }


    const onSelectRelationType = (value: string) => {
        setRelationType(Number(value));
        let relationType = relationTypes.find((rt) => rt.id === parseInt(value));
        let relationDataList = relationList.filter((rl) => rl.type == relationType.name);

        if (relationDataList && relationDataList.length > 0) {
            // If there are related items, you can handle them here
            setShowRelationDataList(true);
            setFinalRelationList(relationDataList);
        }

    }

    return (
        <div className="udp-modal-overlay" style={{width: '30%', left: '35%'}}>
            <div className="udp-modal udp-copyfiles-modal">
                {/* Header */}
                <div className="udp-header">
                    <h2 className="udp-title">העבר קובץ ללקוח</h2>
                    <button
                        className="udp-close-button"
                        type="button"
                        onClick={onClose}
                        aria-label="סגירה"
                    >
                        ×
                    </button>
                </div>

                {/* Body */}
                <div className="udp-body">
                    {/* File details */}
                    <div className="udp-form-row">
                        <label className="udp-label">קובץ להעברה</label>
                        <div className="udp-file-details">
                            <span className="udp-file-name">{documentDetails.filePath}</span>
                            <span className="udp-file-size">({(Number(documentDetails.fileSize) / 1024).toFixed(2)} KB)</span>
                        </div>
                    </div>
                    {/* Search client */}
                    <div className="udp-form-row">
                        <label className="udp-label">חפש לקוח</label>

                        <div className="udp-autocomplete-wrapper">
                            <input
                                type="text"
                                className="udp-select udp-autocomplete-input"
                                placeholder="הקלד שם ..."
                                value={
                                    customerSearch ||
                                    (customersList.find((c) => c.value === customerChosen)?customersList.find((c) => c.value === customerChosen).label+'-'+customersList.find((c) => c.value === customerChosen).identifier : '')
                                }
                                onChange={(e) => {
                                    setCustomerSearch(e.target.value);
                                    setIsCustomerListOpen(true);
                                }}
                                onFocus={() => setIsCustomerListOpen(true)}
                                onBlur={() => {
                                    // small delay so click on item will still fire
                                    setTimeout(() => setIsCustomerListOpen(false), 150);
                                }}
                            />

                            {isCustomerListOpen && filteredCustomers.length > 0 && (
                                <ul className="udp-autocomplete-list">
                                    {filteredCustomers.map((client) => (
                                        <li
                                            key={client.value}
                                            className="udp-autocomplete-item"
                                            onMouseDown={() => {
                                                // onMouseDown so it fires before input blur
                                                setCustomerChosen(client.value);
                                                setCustomerSearch(client.label);
                                                setIsCustomerListOpen(false);
                                            }}
                                        >
                                            {client.label}-{client.identifier}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>


                    {/* Object + Folder */}
                    <div className="udp-form-row udp-form-row--two-cols">
                        <div className="udp-field">
                            <label className="udp-label">סוג שיוך</label>
                            <select className="udp-select" value={relationType}
                                onChange={(e: any) => onSelectRelationType(e.target.value)}

                            >
                                <option value={-1}>בחר סוג</option>
                                {relationTypes.filter(rt => rt.id !== -1).map((rt) => (
                                    <option key={rt.id} value={rt.id}>
                                        {getNameInHebrew(rt.name)}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="udp-field">
                            <label className="udp-label">שיוך</label>
                            <select className="udp-select"
                                value={relationId}
                                onChange={(e: any) => setRelationId(e.target.value)}
                            >
                                <option value={-1}>כללי</option>
                                {finalRelationList.map((rl) => (
                                    <option key={rl.id} value={rl.id}>
                                        {rl.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="udp-form-row udp-form-row--two-cols">
                        <div className="udp-field">
                            <label className="udp-label">תיקיה</label>
                            <select className="udp-select" value={selectedFolder}
                                onChange={(e: any) => setSelectedFolder(e.target.value)}
                            >
                                <option value="">בחר תיקיה</option>
                                {folders.map((folder) => (
                                    <option key={folder.id} value={folder.id}>
                                        {folder.name}
                                    </option>
                                ))}
                            </select>

                        </div>
                    </div>

                    {/* Checkbox */}
                    <div className="udp-form-row udp-checkbox-row">
                        <label className="udp-checkbox-label">
                            <input type="checkbox" value={keepCopy ? "true" : "false"} onChange={() => setKeepCopy(!keepCopy)}
                            />
                            השאר עותק אצל הלקוח הנוכחי
                        </label>
                    </div>
                </div>

                {/* Footer buttons */}
                <div className="udp-footer udp-footer--right">
                    <div />
                    <div className="udp-footer-buttons">
                        <button
                            type="button"
                            className="udp-secondary-btn"
                            onClick={onClose}
                        >
                            סגור
                        </button>
                        <button
                            type="button"
                            className="udp-upload-btn"
                            onClick={(e: any) => onSave(e)}
                        >
                            העבר קובץ
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CopyFiles